import React, { useRef, useState } from 'react';
const CHECKOUT = 'https://recetario-idol.impultienda.ar/checkout';
const PRECIO = '17';
const VALOR_TOTAL = '57';
const tomos = [{
  n: 1,
  t: 'El Menú Secreto Antes de un Comeback',
  s: 'Lo que se cocina en la semana más exigente de un idol, receta por receta'
}, {
  n: 2,
  t: 'Desayunos de Entrenamiento',
  s: 'Desayunos coreanos calientes y con proteína, listos en menos de 15 minutos'
}, {
  n: 3,
  t: 'Comidas Entre Ensayos',
  s: 'Platos rápidos que se comen en 20 minutos y no te dejan con sueño'
}, {
  n: 4,
  t: 'Noches de Comfort Food',
  s: 'Los cuatro jjigae clásicos, en una sola olla y con el picante a tu medida'
}, {
  n: 5,
  t: 'Snacks de Maratón de Dramas',
  s: 'Tteokbokki, pollo frito coreano y todo lo que acompaña una maratón'
}, {
  n: 6,
  t: 'Comida y Postres para Celebrar con el Fandom',
  s: 'Galbi, bingsu y una mesa completa para compartir en grupo'
}];
const muestras = [{
  t: 'Bibimbap energético de camarín',
  d: 'Se arma la noche anterior y se mezcla recién al comer',
  tomo: 1
}, {
  t: 'Gukbap simplificado',
  d: 'Sopa con arroz lista en menos de 8 minutos',
  tomo: 2
}, {
  t: 'Japchae exprés',
  d: 'Fideos de vidrio salteados en una sola sartén',
  tomo: 3
}, {
  t: 'Kimchi jjigae clásico',
  d: 'El guiso coreano por excelencia, con kimchi bien fermentado',
  tomo: 4
}, {
  t: 'Tteokbokki clásico',
  d: 'El snack callejero más famoso de Corea, hecho en casa',
  tomo: 5
}];
const bonos = [{
  n: 1,
  t: 'Guía de Despensa Coreana Express',
  d: 'Qué comprar, sustitutos y dónde conseguir cada ingrediente.'
}, {
  n: 2,
  t: 'Planificador Semanal de Comidas Idol',
  d: 'Combina las recetas de los 6 tomos en una semana real, con lista de compras.'
}, {
  n: 3,
  t: 'Checklist de una Viewing Party Perfecta',
  d: 'Tiempos, cantidades y roles para organizar una reunión con el fandom.'
}, {
  n: 4,
  t: 'Glosario Visual de Banchan',
  d: 'Los acompañamientos coreanos y con qué plato va cada uno.'
}, {
  n: 5,
  t: 'Guía de Picante para Principiantes',
  d: 'Ajusta el picante de cada receta a tu tolerancia, sin perder sabor.'
}];
const faqs = [{
  q: '¿Necesito experiencia cocinando comida coreana?',
  a: 'No. Cada receta trae cantidades exactas y pasos numerados, y el recetario empieza por platos simples. Si es tu primera vez con estas recetas, la Guía de Despensa te dice qué comprar primero.'
}, {
  q: '¿Voy a conseguir los ingredientes?',
  a: 'Sí. Las recetas usan ingredientes que se consiguen fuera de Corea, y el Bono 1 te da sustitutos para cuando algo no aparece, más una guía de qué tipo de tienda buscar.'
}, {
  q: '¿Es una dieta o un plan para bajar de peso?',
  a: 'No. Es un recetario de cocina coreana real, organizado por momentos del día. No promete resultados de peso ni reemplaza la indicación de un nutricionista.'
}, {
  q: '¿Es muy picante?',
  a: 'Tú decides. Cada receta picante se puede hacer suave, y el Bono 5 te explica cómo bajar o subir el picante en cada plato del libro.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Apenas se aprueba el pago te llega un email con el acceso a los 6 tomos y los 5 bonos en PDF, para leerlos en el celular, la tablet o imprimirlos.'
}, {
  q: `¿Es un pago único?`,
  a: `Sí. Pagas ${PRECIO} USD una sola vez. No hay suscripción ni cobros futuros.`
}];
const slides = [{
  src: 'https://naturia-assets.pages.dev/recetario-idol/1-por-que-bibimbap.webp',
  alt: '¿Por qué bibimbap? Carbohidrato, proteína, vegetales y grasa buena en un solo recipiente'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/2-ingredientes.webp',
  alt: 'Ingredientes del bibimbap para 1 porción abundante'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/3-pasos-1-a-4.webp',
  alt: 'Cómo hacer el bibimbap, pasos 1 a 4'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/4-pasos-5-a-7.webp',
  alt: 'Cómo hacer el bibimbap, pasos 5 a 7'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/5-variacion-sin-carne.webp',
  alt: 'Variación sin carne: tofu firme salteado en cubos'
}];
const Carrusel = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [actual, setActual] = useState(0);
  const ir = (i: number) => {
    const el = ref.current;
    if (!el) return;
    const n = (i + slides.length) % slides.length;
    el.scrollTo({
      left: n * el.clientWidth,
      behavior: 'smooth'
    });
    setActual(n);
  };
  return <div className="relative mx-auto max-w-md" data-id="element-0" data-mp="19vrgnb2a4bdc">
      <div ref={ref} onScroll={e => setActual(Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth))} className="flex snap-x snap-mandatory overflow-x-auto rounded-2xl shadow-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-1" data-mp="19vhs7rwvuc9r">
        {slides.map((s, i) => <img key={s.src} src={s.src} alt={s.alt} width={900} height={1125} loading={i === 0 ? 'eager' : 'lazy'} className="h-auto w-full shrink-0 snap-center" data-id="element-2" data-mp="vybb01rt4lmn" data-mpi={i} />)}
      </div>
      <button aria-label="Anterior" onClick={() => ir(actual - 1)} className="absolute left-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-slate-950/70 text-xl text-white" data-id="element-3" data-mp="3gkwemxgmobf6">‹</button>
      <button aria-label="Siguiente" onClick={() => ir(actual + 1)} className="absolute right-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-slate-950/70 text-xl text-white" data-id="element-4" data-mp="203xjx729t0k3">›</button>
      <div className="mt-4 flex justify-center gap-2" data-id="element-5" data-mp="2ev6ja7vz60af">
        {slides.map((s, i) => <button key={s.src} aria-label={`Ir a la imagen ${i + 1}`} onClick={() => ir(i)} className={`h-2.5 rounded-full transition-all ${i === actual ? 'w-6 bg-violet-600' : 'w-2.5 bg-slate-300'}`} data-id="element-6" data-mp="2jtzn18lgmcxe" data-mpi={i} />)}
      </div>
    </div>;
};
const Cta = ({
  children,
  full = false
}: {
  children: React.ReactNode;
  full?: boolean;
}) => <a href={CHECKOUT} className={`inline-flex items-center justify-center rounded-xl bg-violet-600 px-8 py-4 text-center text-lg font-semibold text-white shadow-lg shadow-violet-600/30 transition hover:bg-violet-700 ${full ? 'w-full' : ''}`} data-id="element-7" data-mp="timzr360daxz">
    {children}
  </a>;
const ImgHueco = ({
  id,
  texto,
  medida
}: {
  id: string;
  texto: string;
  medida: string;
}) => <div id={id} className="flex aspect-[4/3] w-full flex-col items-center justify-center rounded-2xl border-2 border-dashed border-violet-300 bg-violet-50 p-6 text-center text-violet-700" data-id="element-8" data-mp="2as8rwdef9ujd">
    <span className="font-semibold" data-id="element-9" data-mp="25vicztect4zj">{texto}</span>
    <span className="mt-1 text-sm" data-id="element-10" data-mp="2kpeo201w8bqg">{medida}</span>
  </div>;
export function App() {
  const [abierta, setAbierta] = useState<number | null>(0);
  return <div className="min-h-screen bg-white text-slate-900" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-11" data-mp="2fpipigbytcia">
      <style data-id="element-12" data-mp="2pherw3l33osb">{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Poppins:wght@500;600&display=swap'); h1,h2,h3{font-family:Poppins,sans-serif}`}</style>

      {/* Barra superior */}
      <div className="bg-slate-950 px-4 py-2 text-center text-sm text-white" data-id="element-13" data-mp="2yicwamzfpybf">
        Oferta de lanzamiento: <span className="font-semibold text-violet-300" data-id="element-14" data-mp="3i3d5mzjzem01">de {VALOR_TOTAL} USD a {PRECIO} USD</span> por tiempo limitado
      </div>

      {/* 1. Hero */}
      <section className="bg-slate-950 px-5 pb-16 pt-12 text-white" data-id="element-15" data-mp="3n0n2h09p9zxw">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-16" data-mp="384nnd5o6azj9">
          <span className="inline-block rounded-full bg-violet-500/15 px-4 py-1 text-sm font-medium text-violet-300" data-id="element-17" data-mp="3d3qpoicrqrnj">
            6 tomos + 5 bonos · Recetas coreanas reales
          </span>
          <h1 className="mt-5 text-4xl font-semibold leading-tight md:text-5xl" data-id="element-18" data-mp="3443pu0zottwl">
            Deja de buscar recetas coreanas sueltas en diez videos distintos
          </h1>
          <p className="mt-5 text-lg text-slate-300" data-id="element-19" data-mp="2ue21r97c4bho">
            <span className="font-semibold text-white" data-id="element-20" data-mp="2uek5eqwbtrzm">Recetario Idol: Cocina Coreana Real</span> reúne en un solo
            sistema lo que comen los idols de K-pop en cada momento de su rutina: desayunos, comidas entre ensayos,
            guisos de la noche, snacks de maratón y comida para celebrar.
          </p>
          <div className="mt-8 w-full max-w-md" data-id="element-21" data-mp="30ulx1n3wm9px">
            <img id="img-producto" src="https://cdn.magicpatterns.com/uploads/2Qj6T7W4rnWesuZnk5fSNZ/finally_-_Editado.webp" alt="Caja del Recetario Idol: Cocina Coreana Real con los 6 tomos" className="mx-auto h-auto w-full" data-id="element-22" data-mp="2vw0yds4avy3l" />
          </div>
          <div className="mt-8 w-full sm:w-auto" data-id="element-23" data-mp="2hxks22aco9lz">
            <Cta full data-id="element-24" data-mp="2hyceonlyyx04">¡Sí! Quiero el recetario</Cta>
          </div>
          <p className="mt-4 text-sm text-slate-400" data-id="element-25" data-mp="2d485ryt58ewe">
            <span className="text-slate-500 line-through" data-id="element-26" data-mp="286gb4x146eoi">{VALOR_TOTAL} USD</span>{' '}
            <span className="font-semibold text-white" data-id="element-27" data-mp="237n1jfoy77tm">{PRECIO} USD</span> · pago único
          </p>
        </div>
      </section>

      {/* 2. Dolor */}
      <section className="px-5 py-16" data-id="element-28" data-mp="1y78spvfivtuj">
        <div className="mx-auto max-w-3xl" data-id="element-29" data-mp="1u6x6ie7ihlgy">
          <h2 className="text-center text-3xl font-semibold" data-id="element-30" data-mp="1u7zx0l0x9lwc">¿Te suena familiar?</h2>
          <ul className="mt-8 space-y-4 text-lg" data-id="element-31" data-mp="9po0qwqi8u05">
            {['Ves un plato en un drama, buscas la receta y encuentras diez versiones que no coinciden.', 'La receta pide ingredientes que no tienes idea de dónde conseguir.', 'Terminas cocinando siempre lo mismo porque no sabes por dónde seguir.', 'El picante te queda imposible de comer o completamente sin gracia.'].map(p => <li key={p} className="flex gap-3 rounded-xl bg-slate-100 p-4" data-id="element-32" data-mp="3m6b4s3ud9i9k">
                <span className="mt-1 h-3 w-3 shrink-0 rounded-full bg-violet-600" data-id="element-33" data-mp="3m484mqzi28r4" />
                <span data-id="element-34" data-mp="3r5xfo6mq2mf7">{p}</span>
              </li>)}
          </ul>
          <p className="mt-8 text-center text-lg" data-id="element-35" data-mp="3w47dkozu014i">
            Ya sabes que te encanta la comida coreana. <span className="font-semibold" data-id="element-36" data-mp="4qbg8in3vz0q">Lo que falta es un sistema.</span>
          </p>
        </div>
      </section>

      {/* 3. Lo que incluye */}
      <section id="incluye" className="bg-slate-950 px-5 py-16 text-white" data-id="element-37" data-mp="33dpd7vqhsdus">
        <div className="mx-auto max-w-6xl" data-id="element-38" data-mp="38dlevobpvt76">
          <p className="text-center text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-39" data-mp="2f756wsfw5rag">Lo que incluye</p>
          <h2 className="mt-2 text-center text-3xl font-semibold" data-id="element-40" data-mp="2k5ovl0lvdh6i">El recetario completo de 6 tomos</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300" data-id="element-41" data-mp="2p4rs1wnsaf2v">
            Organizado por momento del día, como la rutina de un idol. Elige el momento, abre el tomo y cocina.
          </p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-42" data-mp="1wh5kkdbfqqaq">
            {tomos.map(t => <div key={t.n} className="rounded-2xl border border-slate-800 bg-slate-900 p-6" data-id="element-43" data-mp="21f75l3sf8zou">
                <span className="text-sm font-medium text-violet-300" data-id="element-44" data-mp="26f37mxhk6h1r">Tomo {t.n}</span>
                <h3 className="mt-2 text-xl font-semibold" data-id="element-45" data-mp="2b5jokrkl8ksv">{t.t}</h3>
                <p className="mt-2 text-slate-300" data-id="element-46" data-mp="2b6uryqa4fqjg">{t.s}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. Muestras */}
      <section className="px-5 py-16" data-id="element-47" data-mp="1iopdn1fey84j">
        <div className="mx-auto max-w-4xl" data-id="element-48" data-mp="1ino4j2hyjvpg">
          <h2 className="text-center text-3xl font-semibold" data-id="element-49" data-mp="3vz8r89iv5kgl">Un vistazo a lo que vas a cocinar</h2>
          <div className="mt-8 space-y-3" data-id="element-50" data-mp="3ry6ovjtngsae">
            {muestras.map(m => <div key={m.t} className="flex flex-col justify-between gap-1 rounded-xl border border-slate-200 p-5 sm:flex-row sm:items-center" data-id="element-51" data-mp="3ryoqyx2zu0q8">
                <div data-id="element-52" data-mp="3i092z2z9j7ky">
                  <h3 className="font-semibold" data-id="element-53" data-mp="3hyo9lgoopuoo">{m.t}</h3>
                  <p className="text-slate-600" data-id="element-54" data-mp="3d0mokq7p7lak">{m.d}</p>
                </div>
                <span className="text-sm font-medium text-violet-700" data-id="element-55" data-mp="3d2r3023842p3">Tomo {m.tomo}</span>
              </div>)}
          </div>
          <p className="mt-6 text-center text-slate-600" data-id="element-56" data-mp="3482y4d1k8n0t">Y más de 30 recetas en total, todas paso a paso.</p>
        </div>
      </section>

      {/* 4b. Carrusel: una receta por dentro */}
      <section className="bg-slate-950 px-5 py-16 text-white" data-id="element-57" data-mp="2ua5anrriyu99">
        <div className="mx-auto max-w-6xl" data-id="element-58" data-mp="2u9n6m8ymfbqs">
          <p className="text-center text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-59" data-mp="2pbbv7tsogt6g">Así se ve por dentro</p>
          <h2 className="mt-2 text-center text-3xl font-semibold" data-id="element-60" data-mp="2fn6jzz0hs3vl">Una receta completa, página por página</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300" data-id="element-61" data-mp="2knkhin4gvvfd">El bibimbap energético del Tomo 1, tal como lo vas a encontrar en el recetario.</p>
          <div className="mt-10" data-id="element-62" data-mp="2aod6w7p4aevy"><Carrusel data-id="element-63" data-mp="2anto6orn7mgv" /></div>
        </div>
      </section>

      {/* 5. Bonos */}
      <section className="bg-slate-100 px-5 py-16" data-id="element-64" data-mp="2ydxoon9jb63n">
        <div className="mx-auto max-w-6xl" data-id="element-65" data-mp="2yeha4dye8cmf">
          <h2 className="text-center text-3xl font-semibold" data-id="element-66" data-mp="33d0ui9xc9gco">Y además, 5 bonos incluidos</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-600" data-id="element-67" data-mp="2plm1rbdmq0sf">Vienen con el recetario, sin costo extra.</p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-68" data-mp="2tmpg1tg13orj">
            {bonos.map(b => <div key={b.n} className="rounded-2xl bg-white p-6 shadow-sm" data-id="element-69" data-mp="3hd1vrqhimpso">
                <span className="text-sm font-medium text-violet-700" data-id="element-70" data-mp="3hayw0eqk9iar">Bono {b.n}</span>
                <h3 className="mt-2 text-lg font-semibold" data-id="element-71" data-mp="3m5mo0nkrwuu3">{b.t}</h3>
                <p className="mt-2 text-slate-600" data-id="element-72" data-mp="1an8cam28vl1w">{b.d}</p>
                <p className="mt-4 text-sm font-semibold text-green-700" data-id="element-73" data-mp="15pq08msxkppo">✓ Incluido</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. No es otro recetario */}
      <section className="px-5 py-16" data-id="element-74" data-mp="1ff9k9vsdqpm4">
        <div className="mx-auto max-w-6xl" data-id="element-75" data-mp="1fgawi3l4ti5f">
          <h2 className="text-center text-3xl font-semibold" data-id="element-76" data-mp="1fhcih33orp1x">Esto NO es otro recetario más</h2>
          <p className="mt-2 text-center text-lg text-slate-600" data-id="element-77" data-mp="rrrprshqddfg">Es un sistema completo para tener comida coreana real en tu mesa todos los días.</p>
          <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-78" data-mp="11o4s1ercczlt">
            {[['Recetas reales, paso a paso', 'Cantidades exactas y pasos numerados, sin adivinar.'], ['Ingredientes que se consiguen', 'Pensado para cocinar fuera de Corea, con sustitutos.'], ['Organizado por momento del día', 'Desayuno, entre ensayos, noche, maratón y celebración.']].map(([t, d]) => <div key={t} className="rounded-2xl border border-slate-200 p-6 text-center" data-id="element-79" data-mp="2861ggt9g3e9g">
                <h3 className="text-lg font-semibold" data-id="element-80" data-mp="howfarotifum">{t}</h3>
                <p className="mt-2 text-slate-600" data-id="element-81" data-mp="mmxuv2n1bx1c">{d}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Oferta */}
      <section id="oferta" className="bg-slate-950 px-5 py-16 text-white" data-id="element-82" data-mp="qpukhdazstes">
        <div className="mx-auto max-w-2xl text-center" data-id="element-83" data-mp="vo5rlg9wkptb">
          <p className="text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-84" data-mp="10m7dsa2ml590">Oferta especial de lanzamiento</p>
          <h2 className="mt-2 text-3xl font-semibold" data-id="element-85" data-mp="15jqs19zbpi0y">Recetario Idol completo</h2>
          <img src="https://cdn.magicpatterns.com/uploads/2Qj6T7W4rnWesuZnk5fSNZ/finally_-_Editado.webp" alt="Caja del Recetario Idol: Cocina Coreana Real con los 6 tomos" className="mx-auto mt-8 h-auto w-full max-w-md" data-id="element-86" data-mp="1ab8rftlp7ajt" />
          <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 font-semibold" data-id="element-87" data-mp="1jdi00dxeotuk">
            {['6 tomos completos', '5 bonos incluidos', 'Más de 30 recetas', 'Ingredientes que se consiguen'].map(x => <li key={x} className="flex items-center gap-2" data-id="element-88" data-mp="1yfzwllku9y6o"><span className="text-violet-400" data-id="element-89" data-mp="1tg3slmc566r4">✓</span>{x}</li>)}
          </ul>
          <p className="mt-8 flex flex-wrap items-baseline justify-center gap-x-4" data-id="element-90" data-mp="1ti6tx2iqvmb5">
            <span className="text-2xl font-semibold text-slate-500 line-through" data-id="element-91" data-mp="1ohj1qdis4zfc">{VALOR_TOTAL} USD</span>
            <span className="text-6xl font-semibold text-violet-400" data-id="element-92" data-mp="1kh8nkdku32pe">{PRECIO}</span>
            <span className="text-xl font-semibold text-violet-400" data-id="element-93" data-mp="2h4dd8kxmcogo">USD HOY</span>
          </p>
          <div className="mx-auto mt-8 max-w-lg" data-id="element-94" data-mp="2c7wl7fnatpyb"><Cta full data-id="element-95" data-mp="2c8xyzrvp8qjq">⚡ ¡Sí! Lo quiero hoy</Cta></div>
          <p className="mt-4 text-sm font-medium uppercase tracking-wide text-slate-300" data-id="element-96" data-mp="27etstau9cmjp">Pago único. Sin suscripción. Acceso inmediato.</p>
        </div>
      </section>

      {/* 9. Garantía */}
      <section className="bg-slate-100 px-5 py-12" data-id="element-97" data-mp="2zx7rfcnf4cju">
        <div className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="2zy0rxvvsa5tj">
          <h2 className="text-2xl font-semibold" data-id="element-99" data-mp="2v4o2jjja5uzq">Garantía de 7 días</h2>
          <p className="mt-3 text-slate-700" data-id="element-100" data-mp="t7dx1d6lznea">
            Si el recetario no es para ti, escríbenos dentro de los 7 días posteriores a la compra y solicita el
            reembolso según los términos de la garantía.
          </p>
        </div>
      </section>

      {/* 10. FAQ */}
      <section className="px-5 py-16" data-id="element-101" data-mp="oh7636omjqsv">
        <div className="mx-auto max-w-3xl" data-id="element-102" data-mp="og5nmh5a4214">
          <h2 className="text-center text-3xl font-semibold" data-id="element-103" data-mp="oeujgg7x8s9h">Preguntas frecuentes</h2>
          <div className="mt-8 space-y-3" data-id="element-104" data-mp="ajin64e4atqg">
            {faqs.map((f, i) => <div key={f.q} className="rounded-xl border border-slate-200" data-id="element-105" data-mp="fhk3ihk5sey8" data-mpi={i}>
                <button className="flex w-full items-center justify-between gap-4 p-5 text-left font-semibold" onClick={() => setAbierta(abierta === i ? null : i)} data-id="element-106" data-mp="jrpxuy6a0mo">
                  {f.q}
                  <span className="text-violet-700" data-id="element-107" data-mp="1uxj0cwobsoj6">{abierta === i ? '−' : '+'}</span>
                </button>
                {abierta === i && <p className="px-5 pb-5 text-slate-700" data-id="element-108" data-mp="1zvb2ejiopr13">{f.a}</p>}
              </div>)}
          </div>
        </div>
      </section>

      {/* 11. Cierre */}
      <section className="bg-slate-950 px-5 py-16 text-center text-white" data-id="element-109" data-mp="3ffbofvywa6ej">
        <div className="mx-auto max-w-3xl" data-id="element-110" data-mp="3fh4tj6tv0ikf">
          <h2 className="text-3xl font-semibold" data-id="element-111" data-mp="3u4q05apy0zx3">Una última pregunta</h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-112" data-mp="3u60yuw4j7hhc">
            ¿Vas a seguir buscando recetas sueltas cada vez que se te antoje un plato coreano, o vas a abrir un solo
            recetario con todo listo para empezar hoy?
          </p>
          <p className="mt-6" data-id="element-113" data-mp="2yolytaolq78"><span className="text-slate-500 line-through" data-id="element-114" data-mp="2x54x0h7bb4e">{VALOR_TOTAL} USD</span>{' '}<span className="text-3xl font-semibold" data-id="element-115" data-mp="gxy0zpn5ie9m">{PRECIO} USD</span></p>
          <div className="mt-6" data-id="element-116" data-mp="bylb0w0zgr2t"><Cta data-id="element-117" data-mp="bybltanriny6">¡Sí! Lo quiero hoy</Cta></div>
          <p className="mt-3 text-sm text-slate-400" data-id="element-118" data-mp="bze978lvm89c">Pago único. Sin suscripción. Acceso inmediato.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-5 py-8 text-center text-sm text-slate-500" data-id="element-119" data-mp="2dqrevzvo4k6g">
        <p data-id="element-120" data-mp="1rwsfy27x4yeb">© 2026 Naturia. Todos los derechos reservados.</p>
        <p className="mx-auto mt-2 max-w-2xl" data-id="element-121" data-mp="1rw98jffw9sej">
          Recetas inspiradas en patrones generales de la industria del entretenimiento coreano. Naturia no tiene relación
          con ningún artista, grupo ni agencia de K-pop. Este recetario no es un plan de alimentación ni reemplaza la
          indicación de un profesional de la salud.
        </p>
      </footer>
    </div>;
}